export default function Pricing() {
  const features = [
    { icon: 'ri-file-list-3-line', title: 'Comprehensive ADHD Questionnaire', description: 'In-depth symptom evaluation covering attention, impulsivity, and hyperactivity patterns.' },
    { icon: 'ri-file-text-line', title: 'Diagnostic Report Within 48 Hours', description: 'Receive a thorough written report with findings delivered quickly to your inbox.' },
    { icon: 'ri-team-line', title: 'Collaborative Care', description: 'Your report is designed to support collaborative care with your PCP or psychiatrist for next steps.' },
    { icon: 'ri-shield-check-line', title: 'HIPAA-Compliant', description: 'All data handling meets HIPAA standards to protect your health information.' },
  ];

  const scrollToContact = () => {
    if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'ads_conversion_Contact_Us_1', { 'event_timeout': 2000 });
    }
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-24 bg-gradient-to-b from-white to-stone-50">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-violet-600 font-semibold text-sm uppercase tracking-wide">Simple &amp; Transparent</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-4">
            One Clear Option
          </h2>
          <p className="text-lg text-gray-600 max-w-xl mx-auto">
            Everything you need for a professional ADHD assessment — no hidden fees, no confusing tiers.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl border-2 border-violet-100 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-violet-600 to-violet-500 px-10 py-10 text-center">
            <span className="inline-block bg-white/20 text-white text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              Basic Assessment
            </span>
            <div className="flex items-center justify-center gap-3 mb-1">
              <span className="text-white/60 text-2xl font-semibold line-through">$299</span>
              <span className="bg-yellow-400 text-yellow-900 text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full">Promo Price</span>
            </div>
            <div className="flex items-end justify-center gap-2">
              <span className="text-7xl font-bold text-white">$199</span>
              <span className="text-white/80 text-base mb-3">one-time</span>
            </div>
            <p className="text-white/80 text-sm mt-2">Limited-time offer · Regular price $299 · No subscription. No surprises.</p>
          </div>

          {/* Features Grid */}
          <div className="px-10 py-10">
            <div className="grid md:grid-cols-2 gap-6 mb-10">
              {features.map((feature, idx) => (
                <div key={idx} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-violet-50 rounded-xl flex-shrink-0">
                    <i className={`${feature.icon} text-lg text-violet-600`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-gray-900 mb-0.5">{feature.title}</p>
                    <p className="text-xs text-gray-500 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center">
              <button
                onClick={scrollToContact}
                className="inline-block bg-violet-600 text-white px-12 py-4 rounded-full text-base font-semibold hover:bg-violet-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg shadow-violet-200"
              >
                Get Started — $199
              </button>
              <p className="text-xs text-gray-400 mt-3">Fill out the form below · Results within 48 hours</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
